/** @type {import('../help-index.js').HelpSidebarItem} */
export const MET_ART_RANKING_ITEM = {
  id: 'products_ranking',
  screenId: 'met-art-ranking',
  label: 'Ranking de ventas',
  description: 'Productos más y menos vendidos, y artículos sin ventas en el período.',
  detail: {
    sections: [
      {
        title: 'Para qué sirve',
        intro:
          'Ves qué productos facturaron más y cuáles casi no se movieron. También aparecen artículos activos y vendibles que no tuvieron ventas en el rango elegido.',
      },
      {
        title: 'Paso 1 — Elegir período',
        bullets: [
          'Atajos: Hoy, Semana, Mes, Mes anterior o Personalizado (desde / hasta + Aplicar).',
          'Los importes se muestran en pesos al tipo de cambio de cada factura.',
        ],
      },
      {
        title: 'Paso 2 — Leer el ranking',
        bullets: [
          '15 productos más vendidos — barras horizontales por importe facturado.',
          '15 productos menos vendidos — los de menor facturación (con ventas en el período).',
          'Productos sin ventas — listado de artículos vendibles activos que no figuran en facturas del período.',
        ],
      },
    ],
  },
}
